import PageHead from "../Head";

import Context from "@/context/Context";
import VerifyEmail from "@/my_components/_VerifyEmail/VerifyEmail";

const VerifyEmailPage = () => {
  return (
      <Context>
        <PageHead title="Verify Your Email | SmartTech Academy" />

        <VerifyEmail />
      </Context>
  );
};

export default VerifyEmailPage;
